export const PAYMENT_ANNUAL_UPSELL_VARIANTS = Object.freeze({
    CONTROL: 'control',
    CHECKBOX: 'annual_checkbox',
    CTA: 'annual_cta',
});

export const AbTestRelated = {};
